let currentPage = 1; // Global variable to track the current page
let isLoading = false;
let lastUrl = window.location.href; // Track the last URL to detect changes

function getLatestProductGridContainer() {
  return document.querySelector("#ProductGridContainer");
}

function getLatestProductGridUl() {
  const container = getLatestProductGridContainer();
  return container ? container.querySelector("#product-grid") : null;
}

function initializeInfiniteScroll() {
  console.log("Initializing infinite scroll...");
  const productGridContainer = getLatestProductGridContainer();
  const productGridUl = getLatestProductGridUl();

  if (!productGridContainer || !productGridUl) {
    console.error("ProductGridContainer or product-grid not found.");
    return;
  }

  // Ensure currentPage starts at 1 on initialization
  currentPage = 1;

  async function loadMoreProducts() {
    if (isLoading) return;
    isLoading = true;

    // Get current URL and append page and view parameters
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("page", currentPage + 1);
    currentUrl.searchParams.set("view", "ajax");
    const fetchUrl = currentUrl.toString();

    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error("Network error.");

      const newProductsHTML = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = newProductsHTML;

      const newProducts = tempDiv.querySelectorAll("#product-grid > li");

      newProducts.forEach((product) => {
        const latestGridUl = getLatestProductGridUl();
        if (latestGridUl) {
          latestGridUl.appendChild(product);
        }
      });

      currentPage++; // Increment the page number
      isLoading = false;
    } catch (error) {
      console.error("Error fetching products:", error);
      isLoading = false;
    }
  }

  window.addEventListener("scroll", () => {
    const scrollPosition = window.innerHeight + window.scrollY;
    const triggerPosition = document.body.offsetHeight - 2000;

    if (scrollPosition >= triggerPosition && !isLoading) {
      loadMoreProducts();
    }
  });
}

function resetOnUrlChange() {
  const currentUrl = window.location.href;

  // If the URL after /collections changes, reset the page
  if (currentUrl !== lastUrl) {
    lastUrl = currentUrl; // Update the last known URL
    currentPage = 1; // Reset the current page

    const productGridUl = getLatestProductGridUl();
    if (productGridUl) productGridUl.innerHTML = ""; // Clear existing products

    initializeInfiniteScroll(); // Reinitialize infinite scroll with the new URL
  }
}

initializeInfiniteScroll();

// Continuously monitor URL changes
setInterval(resetOnUrlChange, 500); // Check for URL changes every 500ms
